import { useReactToPrint } from 'react-to-print';
import { useRef } from 'react';

const ResumePreview = ({ data }) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <div className="flex flex-col items-center">
      <div ref={componentRef} className="p-10 bg-white min-h-[297mm] w-[210mm] shadow-2xl mx-auto font-sans">
        {/* Header */}
        <div className="mb-6 flex items-start space-x-6">
          {data.personalInfo.profileImage && (
            <div className="flex-shrink-0">
              <img
                src={data.personalInfo.profileImage}
                alt="Profile"
                className="w-20 h-20 object-cover border border-gray-300"
              />
            </div>
          )}
          <div className="flex-1">
            <h1 className="text-4xl font-bold text-gray-800 uppercase tracking-wide mb-2">
              {data.personalInfo.fullName || "Your Name"}
            </h1>
            <div className="text-gray-600 text-sm">
              {data.personalInfo.email && <span>{data.personalInfo.email}</span>}
              {data.personalInfo.phone && <span> | {data.personalInfo.phone}</span>}
              {data.personalInfo.address && <span> | {data.personalInfo.address}</span>}
            </div>
          </div>
        </div>

        {/* Summary */}
        {data.personalInfo.summary && (
          <section className="mb-6">
            <h2 className="text-xl font-bold text-blue-800 border-b-2 border-blue-800 pb-1 mb-3">Professional Summary</h2>
            <p className="text-gray-700 leading-relaxed">{data.personalInfo.summary}</p>
          </section>
        )}

        {/* Experience */}
        {data.experience.length > 0 && (
          <section className="mb-6">
            <h2 className="text-xl font-bold text-blue-800 border-b-2 border-blue-800 pb-1 mb-3">Work Experience</h2>
            {data.experience.map((exp, i) => (
              <div key={i} className="mb-4">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-lg">{exp.role}</h3>
                  <span className="text-sm text-gray-600">{exp.duration}</span>
                </div>
                <p className="text-blue-600 font-medium mb-2">{exp.company}</p>
                <p className="text-gray-700 text-sm leading-relaxed">{exp.description}</p>
              </div>
            ))}
          </section>
        )}

        {/* Education */}
        {data.education.length > 0 && (
          <section className="mb-6">
            <h2 className="text-xl font-bold text-blue-800 border-b-2 border-blue-800 pb-1 mb-3">Education</h2>
            {data.education.map((edu, i) => (
              <div key={i} className="mb-3">
                <div className="flex justify-between">
                  <h3 className="font-bold">{edu.degree}</h3>
                  <span className="text-sm text-gray-600">{edu.year}</span>
                </div>
                <p className="text-gray-700">{edu.school}</p>
              </div>
            ))}
          </section>
        )}

        {/* Skills */}
        {data.skills.length > 0 && (
          <section className="mb-6">
            <h2 className="text-xl font-bold text-blue-800 border-b-2 border-blue-800 pb-1 mb-3">Skills</h2>
            <div className="flex flex-wrap gap-2">
              {data.skills.map((skill, i) => (
                <span key={i} className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">
                  {skill}
                </span>
              ))}
            </div>
          </section>
        )}

        {/* Projects */}
        {data.projects.length > 0 && (
          <section className="mb-6">
            <h2 className="text-xl font-bold text-blue-800 border-b-2 border-blue-800 pb-1 mb-3">Projects</h2>
            {data.projects.map((proj, i) => (
              <div key={i} className="mb-4">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-bold text-lg">{proj.title}</h3>
                  {proj.link && (
                    <a href={proj.link} target="_blank" rel="noopener noreferrer" className="text-blue-600 text-sm">
                      (Link)
                    </a>
                  )}
                </div>
                <p className="text-gray-700 text-sm leading-relaxed">{proj.description}</p>
              </div>
            ))}
          </section>
        )}
      </div>
      <button 
        onClick={handlePrint} 
        className="mt-6 bg-green-600 text-white px-8 py-3 rounded-full font-bold shadow-lg hover:bg-green-700 transition-colors"
      >
        Download PDF
      </button>
    </div>
  );
};

export default ResumePreview;